import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q20 = ({ history }) => {
  const { t } = useTranslation();
  const Q20Options = useMemo(
    () => [
      {
        id: 0,
        name: t('male'),
        value: 'male',
      },
      {
        id: 1,
        name: t('female'),
        value: 'female',
      },
      {
        id: 2,
        name: t('other'),
        value: 'other',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question20')}
      options={Q20Options}
      nextUrl="f3"
      screenName="q20"
    />
  );
};

export default Q20;
